import React from 'react';
import { Link } from 'gatsby';

import { MenuItem } from '@layouts/Navigation/NavigationProps';
import { NavSections } from '../';

import * as styles from '../../Navigation.module.scss';

export const NavSubmenu: React.FC<{ menuItem: MenuItem }> = ({ menuItem }) => {
	return (
		<>
			{menuItem.child && (
				<ul className={styles.subLinks}>
					{menuItem.child.map((childItem) => (
						<li key={`${childItem.name + childItem.url}`}>
							<Link
								className={styles.menuLink}
								to={menuItem.url + childItem.url}
								partiallyActive={true}
							>
								{childItem.name}
							</Link>
						</li>
					))}
				</ul>
			)}
			{menuItem.sections && <NavSections menuItem={menuItem} />}
		</>
	);
};
